import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Tag from "../../ui-components/molecules/tag/tag";
import { TagColor } from "../../app/data/common/tagColor";

const columnHelper = createColumnHelper<any>();

const MAX_DESCRIPTION_LENGTH = 100;

const getLocationActivityLogColumns = () =>
  [
    columnHelper.accessor("changedAt", {
      id: "changedAt",
      header: "Timestamp",
      cell: (cellProps) => {
        const value = cellProps.getValue();
        const date = new Date(value);
        const formattedParts = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const formattedDate = date.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "2-digit",
        });

        return (
          <div>
            <span>{formattedDate} </span>
            <span className="xgs-location-activitylog__formatedtime">
              {formattedParts}
            </span>
          </div>
        );
      },
      enableColumnFilter: false,
      size: 170,
    }),
    columnHelper.accessor("locationCode", {
      id: "locationCode",
      header: "Location",
      cell: (cellProps) => {
        const row = cellProps.row.original;
        return (
          <div className="row">
            {row.locationCode}
          </div>
        )
      },
      enableColumnFilter: false,
      size: 110,
      minSize: 100,
      maxSize: 130,
    }),
    columnHelper.accessor("terminalName", {
      id: "terminalName",
      header: "Terminal",
      cell: (cellProps) => {
        const row = cellProps.row.original;
        return (
          <div className="row">
            <span>{row.terminalName || "-"}</span>
            {row.terminalNumber !== null && row.terminalNumber !== undefined && (
              <span className="xgs-location-activitylog__terminal-number">
                {" "}{row.terminalNumber}
              </span>
            )}
          </div>
        )
      },
      enableColumnFilter: false,
      size: 200,
    }),
    columnHelper.accessor("action", {
      id: "action",
      header: "Action",
      cell: (cellProps) => {
        const row = cellProps.row.original;
        const action = row?.action;

        const actionColorMap: Record<string, TagColor> = {
          UPDATE: TagColor.ORANGE,
          CREATE: TagColor.GREEN,
          APPROVE: TagColor.GREEN,
          DELETE: TagColor.RED,
          REJECT: TagColor.RED,
          DEACTIVATE: TagColor.RED,
          DELETED: TagColor.RED,
          CREATED: TagColor.GREEN,
          UPDATED: TagColor.ORANGE,
          STAGE_FREIGHT: TagColor.GREY,
        };

        const tagColor = actionColorMap[action] || TagColor.GREY;

        return (
          <div className="xgs-location-activitylog__action-cell">
            <Tag mods={{ color: tagColor }}>{action}</Tag>
          </div>
        );

      },
      enableColumnFilter: false,
      size: 150,
      minSize: 120,
      maxSize: 200,
    }),
    columnHelper.accessor("modifiedBy", {
      id: "modifiedBy",
      header: "Changed by",
      enableColumnFilter: false,
      size: 200,
    }),
    columnHelper.accessor("changeDescription", {
      id: "changeDescription",
      header: "Description",
      cell: (cellProps) => {
        const description = cellProps.getValue() || "";
        const row = cellProps.row.original;
        const isUpdateAction = row?.action === "UPDATE" || row?.action === "UPDATED";
        
        // For UPDATE actions, allow multi-line display
        if (isUpdateAction) {
          return (
            <div 
              className="xgs-location-activitylog__description-cell xgs-location-activitylog__description-cell--multiline"
              style={{
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                maxWidth: "100%",
              }}
            >
              {description}
            </div>
          );
        }
        
        // For CREATE/DELETE, show truncated version if too long
        const isLong = description.length > MAX_DESCRIPTION_LENGTH;
        const truncatedDescription = isLong 
          ? description.substring(0, MAX_DESCRIPTION_LENGTH) + "..." 
          : description;

        return (
          <div 
            className="xgs-location-activitylog__description-cell"
            title={isLong ? description : undefined}
            style={{
              wordBreak: "break-word",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
              cursor: isLong ? "help" : "default",
            }}
          >
            {truncatedDescription}
          </div>
        );
      },
      enableColumnFilter: false,
      size: 300
    })
  ];

export default getLocationActivityLogColumns;

